import { SINE_RANDOM } from 'app/views/home/webgl/particlesOptimised/core/kernels/sine';
import { SineGridPhase } from 'app/views/home/webgl/particlesOptimised/departments/spaces/phases/SineGridPhase';

/**
 * SineWaveGridRandomPhase — FORK of SpacesDepartment._sineWaveGridRandom.
 *
 * VISUAL: the "choppy" sine grid — each column's crest response is itself
 * sampled from the sine table by grid x (xYIncrease = lookup(xRatio) *
 * xIncrease), so wave heights vary organically across the box.
 */
export class SineWaveGridRandomPhase extends SineGridPhase {
	public readonly name = 'SineWaveGridRandom';

	public start(): void {
		this._state.sineType = SINE_RANDOM;

		this._state.xIncrease = 5;
		this._state.maxSineX = 10;
		this._state.minSineX = -10;
		this._state.sineDirection = 1;
		this._state.sineYChange = 0.13;
		this._state.sinePlaySeed = 2.5;

		this.startSine();
	}
}
